module.exports = __webpack_public_path__ + "src/assets/models/micropipette/pipette_holder.fbx";